import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { DeheadingQaQcDto } from '../dto/deheading-qa-qc.dto';
import { DeHeadingSampleDto } from '../dto/deheading-sample.dto';
import { DeheadingSampleService } from './deheading-sample.service';
import { ApiTags } from '@nestjs/swagger';
import { DeheadingSampleJobResponse } from '@gtpl/shared-models/production-management';
import { LogIdRequest } from '../dto/log-id-request';
@ApiTags('deheading-sample')
@Controller('deheading-sample')
export class DeheadingSampleController {
    constructor(private service:DeheadingSampleService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler){}

    @Post('CreateSampleInfo')
    async CreateSampleInfo(@Body() dto:DeheadingQaQcDto){
        try {
            return await this.service.CreateSampleInfo(dto);
        } catch (error) {
            return error;
        }
    }

    @Post('/getSamplesInfoByLogId')
    async getSamplesInfoByLogId(@Body() req:LogIdRequest): Promise<DeheadingSampleJobResponse> {
        try {
            return await this.service.getSamplesInfoByLogId(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DeheadingSampleJobResponse, error);
        }
    }
}
